import { render } from "./ResumeCourse.vue?vue&type=template&id=6b0dd02a&scoped=true"
const script = {}

import "./ResumeCourse.vue?vue&type=style&index=0&id=6b0dd02a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b0dd02a"

export default script